(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
      this.predictiveSearch?.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vainilla-category-navigation"] && !Shopify.designMode) return;
  try {
    
  function showPlannedCategory() {
    document.querySelectorAll('[data-vainilla-preview-page]').forEach(container => {
      const match = [...container.querySelectorAll('template[data-category-path]')].find(item => item.dataset.categoryPath === window.location.pathname);
      if (match) container.replaceChildren(match.content.cloneNode(true));
    });
  }
  showPlannedCategory();
  document.addEventListener('shopify:section:load', showPlannedCategory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vainilla-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vainilla-hero-carousel')) {
    customElements.define('vainilla-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = Array.from(this.querySelectorAll('.vs-hero__slide'));
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.sequence = 0;
        this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.onScreen = false;
        this.editorSelected = false;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 7000);
        this.querySelector('.vs-hero__controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), { signal });
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.slideIndex), true), { signal }));
        this.toggle?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateToggle();
          this.schedule();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, { signal });
        this.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
        }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const moveFocus = this.slides.some(slide => slide.contains(event.target));
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true, moveFocus);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', event => {
          if (event.matches) this.paused = true;
          this.updateToggle();
          this.schedule();
        }, { signal });
        const viewport = this.querySelector('.vs-hero__viewport');
        viewport.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, dragging: false };
          this.schedule();
        }, { signal });
        viewport.addEventListener('pointermove', event => {
          if (!this.pointer || this.pointer.id !== event.pointerId) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          if (Math.abs(dx) > 16 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.pointer.dragging = true;
            viewport.setPointerCapture(event.pointerId);
            event.preventDefault();
          }
        }, { signal, passive: false });
        document.addEventListener('pointerup', event => {
          if (!this.pointer || this.pointer.id !== event.pointerId) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          const swiped = Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5;
          this.pointer = null;
          if (swiped) {
            this.suppressClickUntil = Date.now() + 500;
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          } else {
            this.schedule();
          }
        }, { signal });
        document.addEventListener('pointercancel', () => { this.pointer = null; this.schedule(); }, { signal });
        viewport.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (selected < 0) return;
          this.editorSelected = true;
          this.go(selected, false);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.onScreen = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.updateToggle();
      }
      async go(index, announce = false, moveFocus = false) {
        clearTimeout(this.timer);
        const next = (index + this.slides.length) % this.slides.length;
        const sequence = ++this.sequence;
        const image = this.slides[next].querySelector('img');
        if (image) {
          image.loading = 'eager';
          try { await image.decode(); } catch {}
        }
        if (!this.isConnected || sequence !== this.sequence) return;
        this.index = next;
        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
        if (moveFocus) (this.slides[next].querySelector('a') || this.dots[next]).focus({ preventScroll: true });
        if (announce) {
          this.querySelector('[data-status]').textContent = this.dataset.statusTemplate
            .replace('[current]', String(next + 1)).replace('[total]', String(this.slides.length));
        }
        this.schedule();
      }
      updateToggle() {
        if (!this.toggle) return;
        this.toggle.dataset.paused = String(this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || this.pointer || this.editorSelected || !this.onScreen || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.sequence++;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
